import { createFileRoute } from "@tanstack/react-router";
import { PosVNextLP } from "@/components/posvnext/PosVNextLP";
import profLeandro from "@/assets/orto/prof-leandro.jpg.asset.json";

const TITLE = "Pós em Fisioterapia em Traumatologia | Versão B | FEO";
const DESC =
  "Versão B da LP: pós-graduação online em Traumatologia: 14 módulos, 360h, reconhecida pelo MEC. Foco em pré e pós-operatório e reabilitação cirúrgica.";
const URL = "https://fisioemortopedia.com.br/trauma2";

export const Route = createFileRoute("/trauma2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: TraumaLP2,
});

function TraumaLP2() {
  return (
    <PosVNextLP
      product="trauma"
      heroEyebrow="Pós-Graduação · 100% online · MEC"
      heroTitle="Fisioterapia em Traumatologia do pré ao pós-cirúrgico"
      heroTitleHighlight="pré ao pós-cirúrgico"
      heroSubtitle="Conduza o paciente cirúrgico com clareza, da preparação pré-operatória ao retorno funcional, com protocolos baseados em evidência e raciocínio integrado."
      promessas={[
        "Estruturar preparação pré-operatória que reduz tempo de alta",
        "Reabilitar fraturas e pós-cirúrgico com critério de progressão",
        "Decidir carga e exercício em cada fase de cicatrização",
        "Conduzir o retorno funcional sem recidiva",
      ]}
      personas={[
        {
          titulo: "Fisio hospitalar",
          desc: "Que quer dominar o pré e pós imediato com segurança e protocolo claro.",
        },
        {
          titulo: "Fisio ambulatorial",
          desc: "Que recebe o paciente operado e quer conduzir a reabilitação completa.",
        },
        {
          titulo: "Fisio que quer especialização",
          desc: "Que busca certificação MEC e referência em reabilitação cirúrgica.",
        },
      ]}
      coordenadorNome="Leandro Fukusawa"
      coordenadorFoto={profLeandro.url}
      coordenadorQuote="O pós-operatório bem feito começa antes da cirurgia. Quem entende isso muda o desfecho do paciente."
      coordenadorBio="Coordenador da pós em Fisioterapia em Traumatologia da FEO. Especialista em reabilitação musculoesquelética e pós-cirúrgica, com mais de 15 anos de prática clínica e ensino, e produção científica indexada."
      ementaSubtitle="Grade completa, professores e cronograma da pós em Traumatologia."
      whatsappUrl="https://nimble.li/o9yokpkm"
    />
  );
}
